import React, { useContext } from "react";
import { ProductBuilderSelection } from "../../../types/ProductBuilderTypes";
import TrackingUtil from "../../../utils/tracking";
import { ProductContext } from "../../../contexts/ProductContextProvider";
import { ProductOptionsTranslations } from "@vp/product-options-ui";
import { PageStaticDataContext } from "../../../contexts/PageStaticDataContextProvider";
import TemplateOptionSelector from "./selectors/TemplateOptionSelector";

interface TemplateOptionBuilderProps {
  templateSelections: ProductBuilderSelection;
  index: number;
  disabled: boolean;
  removePadding: boolean;
}

const TemplateOptionBuilder = (props: TemplateOptionBuilderProps) => {
  const { index, templateSelections, disabled, removePadding } = props;
  const { locale } = useContext(PageStaticDataContext);
  const { designOptions, selectDesignOptions } = useContext(ProductContext);

  return (
    <ProductOptionsTranslations locale={locale}>
      <TemplateOptionSelector
        builderSelection={templateSelections}
        removePadding={removePadding}
        selectorIndex={index}
        key={`on-page-selector-${index}`}
        disabled={disabled}
        onChange={(newValue: string | null) => {
          TrackingUtil.trackBuilderSelection({
            optionKey: templateSelections.property.key,
            valueKey: newValue || "",
          });
          selectDesignOptions({
            ...designOptions,
            [templateSelections.property.key]: newValue || "",
          });
        }}
      />
    </ProductOptionsTranslations>
  );
};

export default TemplateOptionBuilder;
